/*SYSTEM IMPORTS*/
    import React, {Fragment} from 'react'
    import c from 'classnames'

    import Popup, {PopupText} from "components/ui/Popup"

    import Img from "components/Img"

    import './style'
    import './media'

    import RatingScreen from "./images/rating-screen.svg"
    import Modal from "components/Modal"

    import AppCore from 'cores/AppCore'

    const getClassName = (rating) => {
        if ((rating >= 8)) {
            return  "good"
        } else if(rating < 8 && rating >= 4){
            return "normal"
        } else if((rating < 4)){
            return "bad"
        }
    }

    const Rating = ({ clickable = true, withLabel = true, value: rating = 0, className }) => {
        const linkNode = React.useRef(null)

        const [popupNode, setPopupNode] = React.useState(false)
        const [openPopup, setOpenPopup] = React.useState(false)

        const togglePopup = () => clickable && setOpenPopup(!openPopup)
        const closePopup = () => setOpenPopup(false)

        React.useEffect(() => {
            const handleDocumentClick = (e) => {
                if (openPopup) {
                    if (
                        e.target.closest('.rating-info-popup') != popupNode
                    ) {
                        closePopup()
                    }
                }
            }

            document.addEventListener("click", handleDocumentClick)

            return () => document.removeEventListener("click", handleDocumentClick)
        }, [])

        console.log("change popup", openPopup)

        return (
            <Fragment>
                <div
                    ref={linkNode}
                    className={c("rating", getClassName(rating), className)}
                    // onClick={togglePopup}
                >
                    <div className="rating__icon">
                        {Math.round(rating * 10) / 10}
                    </div>

                    {withLabel &&
                        <div className="rating__label">
                            { AppCore.Interfaces.t( "DoctorLanding.Ui.Rating.Index.TextRating" ) }
                        </div>
                    }
                </div>

                <Modal
                    isOpen={clickable && openPopup === true}
                    onRequestClose={togglePopup}
                >
                    <Popup
                        className="rating-info-popup left"
                        onRef={setPopupNode}
                        onClose={closePopup}
                    >
                        <PopupText>
                            <p>
                                { AppCore.Interfaces.t( "DoctorLanding.Ui.Rating.Index.PopupText" ) }
                            </p>

                            <div className="rating-screen">
                                <Img src={RatingScreen}/>
                            </div>

                            <div className="term">
                                <div className="name">
                                    { AppCore.Interfaces.t( "DoctorLanding.Ui.Rating.Index.PopupTextHeaderPartOne" ) }
                                </div>

                                <div className="value">
                                    { AppCore.Interfaces.t( "DoctorLanding.Ui.Rating.Index.PopupTextHeaderPartTwo" ) }
                                </div>
                            </div>
                        </PopupText>
                    </Popup>
                </Modal>
            </Fragment>
        )
    }

    export default Rating